import { ReactComponent as AddIcon } from "../../images/add.svg";

const icons = {
  add: <AddIcon />,
  remove: <AddIcon style={{ transform: "rotate(45deg)" }} />,
};

const IconButton = props => {
  let iconName = props.icon ? props.icon : null;
  let icon = null;

  try {
    icon = icons[iconName];
  } catch (err) {
    console.warn(
      `Provided icon ${iconName} not available in IconButton component`
    );
  }

  let normalProps = { ...props };
  delete normalProps["icon"];

  return (
    <div className="spot-button">
      <button {...normalProps} className="icon-button">
        {icon !== undefined && icon}
        {props.text}
      </button>
    </div>
  );
};

export default IconButton;
